
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as bookDggUPKxsxHXpVZQZ0_4533zVrR3Hn6ezbtGhlOLzA8iK4Meta } from "/vercel/path0/pages/book.vue?macro=true";
import { default as _91_46_46_46slug_93eD0_45aLJH_SWaJVw5CBvPn8cEE2xWIMXlvr23TEyf8PMMeta } from "/vercel/path0/pages/[...slug].vue?macro=true";
import { default as Confirmation572kElKdg1Sny4TekaRLnLfcy_45ujoVT_45NT99Yi1uRX0Meta } from "/vercel/path0/pages/booking/Confirmation.vue?macro=true";
export default [
  {
    name: "book",
    path: "/book",
    component: () => import("/vercel/path0/pages/book.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/vercel/path0/pages/[...slug].vue")
  },
  {
    name: "booking-Confirmation",
    path: "/booking/Confirmation",
    component: () => import("/vercel/path0/pages/booking/Confirmation.vue")
  }
]